<template>
<div class="chapter">
<div class="inner_page">
<p class="p5"><span class="sz"><i></i> </span></p>
<p class="p4"><span class="sz"><i>My prison is the universe,</i></span></p>
<p class="p4"><span class="sz"><i>a maze of stars my cage.</i></span></p>
<p class="p4"><span class="sz"><i>I bear an unremitting curse:</i></span></p>
<p class="p4"><span class="sz"><i>my prison is the universe.</i></span></p>
<p class="p4"><span class="sz"><i>No mercy may my doom reverse</i></span></p>
<p class="p4"><span class="sz"><i>nor pleas my plight assuage.</i></span></p>
<p class="p4"><span class="sz"><i>My prison is the universe—</i></span></p>
<p class="p4"><span class="sz"><i>a maze of stars, my cage</i></span></p>
<p class="p6"><span class="sz"><b></b> </span></p>
<p class="p6"><span class="sz"><b></b> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?5feeb33c